import { getContractDetailsEndpoint } from './contracts';

export function getBundledProductsEndpoint(contractId: string): string {
    return `${getContractDetailsEndpoint(contractId)}/bundled-products`;
}
